import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "lib-flexible-computer";
import myUI from './components'
import 'amfe-flexible';
import 'lib-flexible'
// import './utils/rem'
import V3Scroll from './components/vue3 scroll.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'



createApp(App).use(store).use(router).use(myUI).use(V3Scroll).use(ElementPlus).mount('#app')
